import { CircularProgress, styled } from "@mui/material";

export const RoomsContainerMobile = styled("div")(() => ({
  display: "none",
  marginTop: 24,

  "@media screen and (max-width: 435px)": {
    display: "flex",
    flexDirection: "column",
    gap: 24,
  },
}));

export const GridContainer = styled("div")(() => ({
  "@media screen and (max-width: 435px)": {
    display: "none",
  },
  "& .MuiTableBody-root tr.MuiTableRow-root:nth-child(odd)": {
    backgroundColor: "unset !important",
  },
  "& .MuiTableContainer-root": {
    overflowY: "hidden",
    overflowX: "hidden",
  },
  "& > div > div > div > table > tbody > tr": {
    backgroundColor: "#fff !important",
    "& > td": {
      padding: "0 !important",
    },
    "&:not(:last-child)": {
      borderBottom: "1px solid rgba(237, 245, 251, 1) !important",
    },
  },
}));

export const LoadingWrapper = styled("div")(() => ({
  display: "flex",
  width: "100%",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 300,
}));

export const LoadingSpinner = styled(CircularProgress)(() => ({
  color: "#0055A4 !important",
}));
